__webpack_require__.p = "/apps/atlas-user-admin-ui/";